import React from 'react';
import { Link } from 'react-router-dom';
import { 
  FiCode, 
  FiUsers, 
  FiCloud, 
  FiSmartphone,
  FiGlobe,
  FiTrendingUp,
  FiCpu,
  FiDatabase,
  FiShield,
  FiLayers
} from 'react-icons/fi';
import '../../styles/services.css';
import servicepage3 from '../../images/servicepage3.jpg';

const Services = () => {
  const services = [
    {
      id: 1,
      title: 'Custom Software Development',
      icon: <FiCode />,
      description: 'Tailored software solutions built to meet your specific business requirements and objectives.',
      paragraph: 'We develop custom software applications from scratch, ensuring they align perfectly with your business processes. Our solutions are scalable, maintainable, and built using the latest technologies.'
    },
    {
      id: 2,
      title: 'IT Staffing Solutions',
      icon: <FiUsers />,
      description: 'Access to qualified IT professionals including developers, analysts, and project managers.',
      paragraph: 'We provide dedicated IT professionals for your projects on contract, permanent, or temp-to-hire basis. Our rigorous vetting process ensures you get the right talent with the required skills.'
    },
    {
      id: 3,
      title: 'Cloud Migration & Services',
      icon: <FiCloud />,
      description: 'Seamless migration to cloud platforms and ongoing cloud infrastructure management.',
      paragraph: 'We help businesses migrate to AWS, Azure, or Google Cloud with minimal disruption. Our cloud experts design, implement, and manage scalable cloud architectures.'
    },
    {
      id: 4,
      title: 'Mobile App Development',
      icon: <FiSmartphone />,
      description: 'Native and cross-platform mobile applications for iOS and Android.',
      paragraph: 'We create engaging mobile applications using React Native, Flutter, Swift, and Kotlin. Our apps are optimized for performance and user experience.'
    },
    {
      id: 5,
      title: 'Web Application Development',
      icon: <FiGlobe />,
      description: 'Responsive web applications using modern frameworks and technologies.',
      paragraph: 'We build robust web applications with React, Angular, Vue.js, and Node.js. Our focus is on creating intuitive interfaces and efficient backends.'
    },
    {
      id: 6,
      title: 'IT Consulting',
      icon: <FiTrendingUp />,
      description: 'Strategic IT consulting to optimize your technology infrastructure and processes.',
      paragraph: 'Our IT consultants help you develop technology roadmaps, optimize workflows, and implement best practices for digital transformation.'
    },
    {
      id: 7,
      title: 'AI & Machine Learning',
      icon: <FiCpu />,
      description: 'Implement artificial intelligence and machine learning solutions for business intelligence.',
      paragraph: 'We develop custom AI models, implement GenAI solutions, and create predictive analytics systems to drive data-informed decisions.'
    },
    {
      id: 8,
      title: 'Database Solutions',
      icon: <FiDatabase />,
      description: 'Database design, optimization, and management services for all business sizes.',
      paragraph: 'We design efficient database architectures, optimize query performance, and implement data warehousing solutions.'
    },
    {
      id: 9,
      title: 'Cybersecurity Services',
      icon: <FiShield />,
      description: 'Comprehensive cybersecurity solutions to protect your digital assets.',
      paragraph: 'We conduct security audits, implement security protocols, and provide ongoing monitoring to protect your systems from threats.'
    }
  ];

  const technologies = [
    { name: 'React.js', level: '100%' },
    { name: 'Python', level: '95%' },
    { name: 'Java', level: '90%' },
    { name: 'AWS', level: '95%' },
    { name: 'Node.js', level: '90%' },
    { name: 'React Native', level: '85%' },
    { name: 'MongoDB', level: '90%' },
    { name: 'PostgreSQL', level: '85%' }
  ];

  return (
    <>
      {/* Services Hero */}
      <section className="service-page-hero"
      style={{
          background: `linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)), url(${servicepage3})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
      }}>
        <div className="service-page-container">
          <div className="service-page-hero-content">
            <h1 style={{ color: '#00e7ff' }} className="service-page-title">Our Services</h1>
            <p className="service-page-subtitle">Comprehensive IT solutions and staffing services tailored for your business success</p>
            <p className="service-page-description">
              At VinfoCloud, we provide end-to-end technology services that help businesses 
              innovate, scale, and achieve their digital transformation goals.
            </p>
            <Link to="/contact" className="service-page-btn service-page-btn-primary">Get Started</Link>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="service-page-section service-page-services-section">
        <div className="service-page-container">
          <div className="service-page-section-header">
            <h2 style={{ color: '#00e7ff' }} className="service-page-section-title">Our Service Portfolio</h2>
            <p className="service-page-section-subtitle">
              End-to-end technology solutions designed to meet your business objectives
            </p>
          </div>
          
          <div className="service-page-services-grid">
            {services.map(service => (
              <div className="service-page-card" key={service.id}>
                <div className="service-page-card-icon">
                  {service.icon}
                </div>
                <h3 style={{ color: '#00e7ff' }} className="service-page-card-title">{service.title}</h3>
                <p className="service-page-card-description">{service.description}</p>
                <p className="service-page-card-paragraph">{service.paragraph}</p>
                <Link to="/contact" className="service-page-card-link">
                  Learn More <i className="fa fa-arrow-right"></i>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Expertise Section */}
      <section className="service-page-section service-page-expertise-section">
        <div className="service-page-container">
          <div className="service-page-section-header">
            <h2 style={{ color: '#00e7ff' }} className="service-page-section-title">Our Technical Expertise</h2>
            <p className="service-page-section-subtitle">
              Proficiency across modern technology stacks and platforms
            </p>
          </div>
          
          <div className="service-page-expertise-grid">
            {technologies.map((tech, index) => (
              <div className="service-page-expertise-item" key={index}>
                <div className="service-page-expertise-header">
                  <span className="service-page-tech-name">{tech.name}</span>
                  <span className="service-page-tech-percentage">{tech.level}</span>
                </div>
                <div className="service-page-progress-bar">
                  <div 
                    className="service-page-progress-fill" 
                    style={{ width: tech.level }}
                    data-level={tech.level}
                  ></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="service-page-section service-page-process-section">
        <div className="service-page-container">
          <div className="service-page-section-header">
            <h2 style={{ color: '#00e7ff' }} className="service-page-section-title">Our Process</h2>
            <p className="service-page-section-subtitle">
              A structured approach to delivering successful projects
            </p>
          </div>
          
          <div className="service-page-process-steps">
            <div className="service-page-process-step">
              <div className="service-page-step-number">1</div>
              <h3 style={{ color: '#00e7ff' }} className="service-page-step-title">Discovery & Planning</h3>
              <p className="service-page-step-description">
                We analyze your requirements, define project scope, and create a detailed roadmap.
              </p>
            </div>
            
            <div className="service-page-process-step">
              <div className="service-page-step-number">2</div>
              <h3 style={{ color: '#00e7ff' }} className="service-page-step-title">Design & Prototyping</h3>
              <p className="service-page-step-description">
                We create wireframes, mockups, and prototypes to visualize the final product.
              </p>
            </div>
            
            <div className="service-page-process-step">
              <div className="service-page-step-number">3</div>
              <h3 style={{ color: '#00e7ff' }} className="service-page-step-title">Development</h3>
              <p className="service-page-step-description">
                Our team builds the solution using agile methodologies with regular updates.
              </p>
            </div>
            
            <div className="service-page-process-step">
              <div className="service-page-step-number">4</div>
              <h3 style={{ color: '#00e7ff' }} className="service-page-step-title">Testing & Quality Assurance</h3>
              <p className="service-page-step-description">
                Rigorous testing ensures the solution meets quality standards and requirements.
              </p>
            </div>
            
            <div className="service-page-process-step">
              <div className="service-page-step-number">5</div>
              <h3 style={{ color: '#00e7ff' }} className="service-page-step-title">Deployment & Support</h3>
              <p className="service-page-step-description">
                We deploy the solution and provide ongoing maintenance and support.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section cta-section">
        <div className="cta-content">
            <h2 style={{ color: '#00e7ff' }}>Ready to Start Your Project?</h2>
            <p>
              Let's discuss how VinfoCloud can help you achieve your technology goals 
              with our expert services and solutions.
            </p>
            <div className="cta-buttons">
              <Link to="/contact" className="btn btn-primary">
                Get a Free Consultation
              </Link>
              <Link to="/about" className="btn btn-outline">
                Learn About Us
              </Link>
            </div>
        </div>
      </section>
    </>
  );
};

export default Services;